<template>
  <div class="video-container">
    <div class="stock-video">
      <iframe v-if="videoUrl" class="embed-video" :src="videoUrl" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  props: ['videoId', 'lazy'],
  data() {
    return {
      videoUrl: null,
    };
  },
  mounted() {
    if (this.lazy) {
      setTimeout(() => this.videoUrl = this.youtube, 2000);
    } else {
      this.videoUrl = this.youtube;
    }
  },
  computed: {
    youtube() {
      return `https://www.youtube.com/embed/${this.videoId}`;
    },
  },
};
</script>

<style scoped>
.video-container {
  width: 100%;
}

.stock-video {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}

.embed-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media screen and (orientation:landscape) and (max-width:991px) {
  .video-container {
    width: 100%;
    padding-left: 10%;
    padding-right: 10%;
    background: #000000;
  }
}

@media screen and (min-width:992px) {
  .video-container {
    padding-left: 0%;
    padding-right: 0%;
  }
}
</style>